import BackgroundEmblems from "@readai/common/assets/background-emblems.svg";

export const gray = {
  50: "#F8F8F8",
  100: "#EFEFEF",
  200: "#E4E4E4",
  300: "#D2D2D2",
  400: "#AEAEAE",
  500: "#8D8D8D",
  600: "#656565",
  700: "#525252",
  800: "#343434",
  900: "#151515",
};

export const blue = {
  500: "#4462EF",
};

const blush = {
  50: "#FDEDF1",
  100: "#FCDCE4",
  200: "#F9B8C9",
  300: "#F595AD",
  400: "#F27192",
  500: "#EF4E77",
  600: "#BF3E5F",
  700: "#8F2F47",
  800: "#601F30",
  900: "#301018",
};

const emerald = {
  50: "#E8F9F5",
  100: "#DAF5E5",
  200: "#B5EBCB",
  300: "#91E0B0",
  400: "#6CD696",
  500: "#47CC7C",
  600: "#39A363",
  700: "#2B7A4A",
  800: "#1C5232",
  900: "#0E2919",
};

export const shades = {
  primary: {
    50: "#EDEDFA",
    100: "#DBDAF5",
    150: "#C9C8F0",
    200: "#B7B5EB",
    300: "#9491E0",
    400: "#706CD6",
    500: "#4C47CC",
    600: "#3D39A3",
    700: "#2E2B7A",
    800: "#1E1C52",
    900: "#0F0E29",
  },
  secondary: {
    50: "#ECEFFD",
    100: "#DAE0FC",
    150: "#C6D0FA",
    200: "#B4C0F9",
    300: "#8FA1F5",
    400: "#6981F2",
    500: "#4462EF",
    600: "#364EBF",
    700: "#293B8F",
    800: "#1B2760",
    900: "#0E1430",
  },
  emerald,
  positive: emerald,
  meadow: {
    50: "#E8F9F5",
    100: "#D1F4EC",
    200: "#A3E9D9",
    300: "#75DDC5",
    400: "#47D2B2",
    500: "#19C79F",
    600: "#149F7F",
    700: "#0F775F",
    800: "#0A5040",
    900: "#052820",
  },
  orange: {
    50: "#FDF6ED",
    100: "#FCEDDC",
    200: "#F9DBB8",
    300: "#F5C995",
    400: "#F2B771",
    500: "#EFA54E",
    600: "#BF843E",
    700: "#8F632F",
    800: "#60421F",
    900: "#302110",
  },
  blush,
  negative: blush,
  neutral: {
    50: "#F0F0F0",
    100: "#E0E0E0",
    150: "#D1D1D1",
    200: "#C1C1C1",
    300: "#A3A3A3",
    400: "#848484",
    500: "#656565",
    600: "#515151",
    700: "#3D3D3D",
    800: "#282828",
    900: "#141414",
  },
  ghost: {
    300: "#F5F6FA",
    400: "#F0F2FA",
    500: "#EFF2FC",
    600: "#D9DCE6",
    700: "#C1C3CC",
  },
};

export const overlay = {
  primary: {
    0: "#121212",
    4: "#17161B",
    8: "#1A1825",
    12: "#1F1B2E",
    16: "#231F38",
    20: "#272241",
    24: "#2B254B",
    28: "#2F2854",
  },
};

export const metrics = {
  poor: "#B24444",
  belowAverage: "#BF894A",
  average: "#BFB449",
  good: "#6EB244",
  excellent: "#44B26A",
};

export const avatar = {
  pink: {
    main: "#F5C6D7",
    dark: "#CC346B",
  },
  red: {
    main: "#F5C6CC",
    dark: "#CC3446",
  },
  redOrange: {
    main: "#F5D4C6",
    dark: "#CC6134",
  },
  orange: {
    main: "#F5DFC6",
    dark: "#CC8634",
  },
  yellow: {
    main: "#F2EBC4",
    dark: "#CCB434",
  },
  yellowGreen: {
    main: "#E1F2C4",
    dark: "#80B22D",
  },
  green: {
    main: "#C6F5E1",
    dark: "#2DB27B",
  },
  teal: {
    main: "#C6F2F5",
    dark: "#31B7BF",
  },
  blue: {
    main: "#C6D9F5",
    dark: "#3471CC",
  },
  indigo: {
    main: "#C6C8F5",
    dark: "#4034CC",
  },
  purple: {
    main: "#D5C6F5",
    dark: "#6534CC",
  },
  magenta: {
    main: "#EAABF5",
    dark: "#B734CC",
  },
};

export const shadows = {
  24: "0px 20px 40px -8px rgba(0, 0, 0, 0.18), 0px 0px 1px rgba(0, 0, 0, 0.04)",
  28: "0px 28px 48px -8px rgba(0, 0, 0, 0.2), 0px 0px 1px rgba(0, 0, 0, 0.04)",
};

export const gradients = {
  read: "linear-gradient(48.39deg, #4361EE 23.98%, #7A61FF 80.34%)",
  accent: "linear-gradient(263.15deg, #B0637A -11.06%, #624ECC 85%)",
  data: "linear-gradient(84.04deg, #E99D8D 0%, #7A61FF 99.17%)",
  blueGreen: "linear-gradient(95deg, #4BAEE8 -21.91%, #68B447 123.47%)",
  light:
    "linear-gradient(48.39deg, rgba(67, 97, 238, 0.4) 23.98%, rgba(122, 97, 255, 0.4) 80.34%)",
};

export const opacity = {
  white: {
    5: "#FFFFFF0D",
    10: "#FFFFFF1A",
    20: "#FFFFFF33",
    30: "#FFFFFF4D",
    40: "#FFFFFF66",
    50: "#FFFFFF80",
    80: "#FFFFFFCC",
  },
};

export const transparent = {
  white: {
    2: "rgba(255, 255, 255, 0.02)",
    4: "rgba(255, 255, 255, 0.04)",
    7: "rgba(255, 255, 255, 0.07)",
    8: "rgba(255, 255, 255, 0.08)",
    10: "rgba(255, 255, 255, 0.10)",
    12: "rgba(255, 255, 255, 0.12)",
    16: "rgba(255, 255, 255, 0.16)",
    20: "rgba(255, 255, 255, 0.2)",
    25: "rgba(255, 255, 255, 0.25)",
    30: "rgba(255, 255, 255, 0.3)",
    40: "rgba(255, 255, 255, 0.4)",
    50: "rgba(255, 255, 255, 0.5)",
    60: "rgba(255, 255, 255, 0.6)",
    70: "rgba(255, 255, 255, 0.7)",
    80: "rgba(255, 255, 255, 0.8)",
  },
  black: {
    2: "rgba(0, 0, 0, 0.02)",
    4: "rgba(0, 0, 0, 0.04)",
    7: "rgba(0, 0, 0, 0.07)",
    8: "rgba(0, 0, 0, 0.08)",
    10: "rgba(0, 0, 0, 0.10)",
    12: "rgba(0, 0, 0, 0.12)",
    16: "rgba(0, 0, 0, 0.16)",
    20: "rgba(0, 0, 0, 0.2)",
    25: "rgba(0, 0, 0, 0.25)",
    30: "rgba(0, 0, 0, 0.3)",
    40: "rgba(0, 0, 0, 0.4)",
    50: "rgba(0, 0, 0, 0.5)",
    60: "rgba(0, 0, 0, 0.6)",
    70: "rgba(0, 0, 0, 0.7)",
    80: "rgba(0, 0, 0, 0.8)",
  },
};

export const background = {
  default: "#FAFAFA",
  navbar: "#2F2854",
  sidenav:
    "linear-gradient(0deg, rgba(122, 97, 255, 0.16), rgba(122, 97, 255, 0.16)), #121212;",
  lightBlue: "#F1F4FF",
  emblem: `url(${BackgroundEmblems}), ${gradients.read}`,
};
